module.exports = __webpack_public_path__ + "img/products-2.51f7cac.webp";